import { FunctionDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const UseFormField = () => (
  <FunctionDocs entry="useFormField">
    <ComponentExample
      name="Update form field"
      import={import("examples/Forms/UseFormField/UpdateFormFieldExample")}
      rawImport={import(
        "examples/Forms/UseFormField/UpdateFormFieldExample?raw"
      )}
    />
    <ComponentExample
      name="Mutate field data"
      import={import("examples/Forms/UseFormField/MutateFieldDataExample")}
      rawImport={import(
        "examples/Forms/UseFormField/MutateFieldDataExample?raw"
      )}
    />
  </FunctionDocs>
);

export default UseFormField;
